import { List } from 'immutable';

const memoizeByRef = (fn) => {
  let lastArgs;
  let lastResult;
  return (...args) => {
    const key = args[0] === lastArgs?.[0] && args[1] === lastArgs?.[1];
    if (key) return lastResult;
    lastArgs = args;
    lastResult = fn(...args);
    return lastResult;
  };
};

export { memoizeByRef };

export function generateSelectEntityById(entitySelector) {
  return (id) => (state) => entitySelector(state).get(id);
}

export function generateSelectEntityByEntityInfo(entitySelector, EntityModel) {
  const selectById = generateSelectEntityById(entitySelector);
  return (entityInfo) => selectById(EntityModel.getId(entityInfo));
}

export function generateSelectEntitiesByIdsList(entitySelector) {
  const selectByIds = memoizeByRef((entityCollection, ids) => {
    const entities = ids?.map((id) => entityCollection.get(id));
    return entities?.filter((entity) => !!entity);
  });
  return (ids = List(), filtered = true) => (state) => {
    if (filtered) return selectByIds(entitySelector(state), ids);
    const entityCollection = entitySelector(state);
    return ids?.map((id) => entityCollection.get(id));
  };
}

export function generateSelectEntitiesByEntitiesList(entitySelector, EntityModel) {
  const selectByIds = generateSelectEntitiesByIdsList(entitySelector);
  const getIds = memoizeByRef((entities) => entities?.map((entity) => EntityModel.getId(entity)));
  return (entities, filtered = true) => {
    const ids = getIds(entities);
    return filtered ? selectByIds(ids) : selectByIds(ids, false);
  };
}
